import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import capi from "@/lib/customerApi";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { AuthShell } from "@/pages/customer/AuthShell";
import { Field } from "@/pages/customer/SignUp";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [f, setF] = useState({ password: "", confirm_password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await capi.post("/auth/reset-password", { token, ...f });
      toast.success("Password updated. Please sign in.");
      nav("/signin", { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Set a new password" testid="reset-page">
      {!token ? (
        <p className="text-sm text-muted-foreground" data-testid="reset-missing-token">This reset link is invalid. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field id="rp-password" label="New Password" type="password" value={f.password} onChange={(e) => setF((s) => ({ ...s, password: e.target.value }))} required hint="At least 8 characters" />
          <Field id="rp-confirm" label="Confirm New Password" type="password" value={f.confirm_password} onChange={(e) => setF((s) => ({ ...s, confirm_password: e.target.value }))} required />
          <Button type="submit" disabled={busy} className="w-full rounded-none h-11 font-bold uppercase tracking-wide" data-testid="rp-submit">{busy ? "Updating…" : "Update password"}</Button>
        </form>
      )}
      <Link to="/signin" className="block text-center text-sm text-muted-foreground hover:text-primary mt-6" data-testid="rp-back-signin">← Back to sign in</Link>
    </AuthShell>
  );
}
